import type { ImageSource } from "@compass/shared/schema/image";
import type { ImgHTMLAttributes } from "react";

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "srcSet" | "width" | "height"> & {
    image: ImageSource;
    /**
     * How wide the image is drawn, for the browser to pick a variant, e.g.
     * "128px" or "(min-width: 640px) 128px, 96px". Required when the image
     * has variants — without it the browser assumes 100vw and overfetches.
     */
    sizes: string;
};

/**
 * PRTL-1349: an <img> that offers the image's WebP size variants via
 * `srcset`, reserves its intrinsic aspect ratio, and loads lazily. With no
 * variants it is a plain lazy <img> of the original.
 */
export const ResponsiveImage = ({ image, sizes, alt, ...props }: Props) => (
    <img
        loading="lazy"
        decoding="async"
        {...props}
        src={image.src}
        srcSet={image.srcSet}
        sizes={image.srcSet ? sizes : undefined}
        width={image.width}
        height={image.height}
        alt={alt}
    />
);
